import { jsxs as R, jsx as n } from "react/jsx-runtime";
import { forwardRef as $, useState as I, useRef as j, useImperativeHandle as L, useMemo as h, useEffect as V } from "react";
import k from "./extras/ErrorMessage.js";
import q from "./extras/AutoCompleteList.js";
import { useFormAutoComplete as B } from "./extras/FormAutoCompleteProvider.js";
import '../../assets/style6.css';/* empty css                   */
const J = $(
  ({
    label: l,
    errorMsg: t,
    containerProps: i,
    autoCompleteKey: r,
    shouldShowAutoComplete: f = !0,
    defaultValue: C,
    value: u,
    onBlur: m,
    onChange: s,
    ...x
  }, y) => {
    const [p, a] = I((u || C) ?? ""), [d, o] = I(!1), c = j(null);
    L(y, () => c.current);
    const b = h(
      () => typeof t == "string" && (t != null || /^[\s]*$/.test(t)),
      [t]
    ), v = h(() => l != null || /^[\s]*$/.test(l), [l]), { data: A, displayedKeys: E } = B(r, (e) => {
      a(e ?? ""), s?.({ target: { value: e } });
    });
    V(() => {
      a(u ?? "");
    }, [u]);
    const N = (e) => {
      s?.(e), a(e.target.value), d || o(!0);
    }, O = (e) => {
      m?.(e), o(!1);
    };
    return /* @__PURE__ */ R(
      "div",
      {
        ...i,
        className: "input-field" + (b ? " error" : "") + ` ${i?.className ?? ""}`,
        children: [
          v ? /* @__PURE__ */ n("label", { className: "input-field-label override-label-styles mb-1 inline-block text-sm font-medium", children: l }) : null,
          /* @__PURE__ */ n(
            "input",
            {
              value: p,
              autoComplete: f ? "off" : void 0,
              onChange: N,
              onBlur: O,
              ref: c,
              ...x
            }
          ),
          f ? /* @__PURE__ */ n(
            q,
            {
              data: A,
              displayedKeys: E,
              field: r,
              isOpen: d,
              query: p,
              handleClose: () => {
                o(!1);
              }
            }
          ) : null,
          /* @__PURE__ */ n(k, { children: t })
        ]
      }
    );
  }
);
export {
  J as default
};
